import { render, staticRenderFns } from "./ContactUsServiceContent.vue?vue&type=template&id=3fbd9596&scoped=true&"
import script from "./ContactUsServiceContent.vue?vue&type=script&lang=js&"
export * from "./ContactUsServiceContent.vue?vue&type=script&lang=js&"
import style0 from "./ContactUsServiceContent.vue?vue&type=style&index=0&id=3fbd9596&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbd9596",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CmsRichText: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsRichText.vue').default,CmsLink: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsLink.vue').default})
